module.exports = __webpack_public_path__ + "img/plus.5ac95e95.svg";